import { useState } from 'react'
import { ClipboardList, CheckCircle2, Clock, AlertCircle, User, ArrowRight } from 'lucide-react'

const initialTasks = [
  { id: 1, title: 'Connect HF Inference API for Typhoon', agent: 'Eng', pillar: 'Brains', status: 'in_progress', priority: 'high', created: '12:00' },
  { id: 2, title: 'Deploy Athena Space via HF Director', agent: 'PM', pillar: 'Brains', status: 'pending', priority: 'high', created: '12:05' },
  { id: 3, title: 'Set up WUPHF office on Stomach', agent: 'CEO', pillar: 'Stomach', status: 'pending', priority: 'medium', created: '12:10' },
  { id: 4, title: 'Audit Cloudflare Worker secrets', agent: 'Shield', pillar: 'Vision', status: 'pending', priority: 'low', created: '12:15' },
]

export default function TaskBoard({ compact = false }) {
  const [tasks, setTasks] = useState(initialTasks)

  const statusConfig = {
    pending: { icon: Clock, color: 'text-gray-500', bg: 'bg-gray-800/40', border: 'border-gray-700' },
    in_progress: { icon: AlertCircle, color: 'text-aith-orange', bg: 'bg-aith-orange/5', border: 'border-aith-orange/20' },
    done: { icon: CheckCircle2, color: 'text-aith-green', bg: 'bg-aith-green/5', border: 'border-aith-green/20' },
  }

  const priorityColor = {
    high: 'text-aith-red',
    medium: 'text-aith-yellow',
    low: 'text-gray-500',
  }

  if (compact) {
    return (
      <div className="space-y-2">
        {tasks.slice(0, 4).map(task => {
          const StatusIcon = statusConfig[task.status].icon
          return (
            <div key={task.id} className={`flex items-center gap-2 px-2 py-1.5 rounded border ${statusConfig[task.status].bg} ${statusConfig[task.status].border}`}>
              <StatusIcon className={`w-3 h-3 ${statusConfig[task.status].color}`} />
              <span className="text-[10px] text-gray-300 flex-1 truncate">{task.title}</span>
              <span className="text-[9px] text-gray-500">{task.agent}</span>
              <ArrowRight className="w-2.5 h-2.5 text-gray-600" />
              <span className="text-[9px] text-gray-400">{task.pillar}</span>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <ClipboardList className="w-4 h-4 text-aith-accent" />
          <h2 className="text-xs font-bold tracking-widest text-gray-500 uppercase">Active Tasks</h2>
        </div>
        <span className="text-[10px] text-gray-500">{tasks.filter(t => t.status !== 'done').length} open</span>
      </div>

      <div className="space-y-2">
        {tasks.map(task => {
          const StatusIcon = statusConfig[task.status].icon
          return (
            <div key={task.id} className={`p-3 rounded-lg border ${statusConfig[task.status].bg} ${statusConfig[task.status].border}`}>
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                  <StatusIcon className={`w-3.5 h-3.5 ${statusConfig[task.status].color}`} />
                  <span className="text-xs font-bold text-gray-200">{task.title}</span>
                </div>
                <span className={`text-[9px] font-bold ${priorityColor[task.priority]}`}>{task.priority}</span>
              </div>
              <div className="flex items-center gap-3 text-[10px] text-gray-500">
                <span className="flex items-center gap-1">
                  <User className="w-2.5 h-2.5" />
                  {task.agent}
                </span>
                <span>→</span>
                <span>{task.pillar}</span>
                <span className="ml-auto">{task.created}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
